module.exports = __webpack_public_path__ + "images/emoji/pound.33acd08ea5b454493b73.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pound.png
// module id = pOAu
// module chunks = 14